import { Component, Input } from "@angular/core";
import { HttpErrorResponse } from "@angular/common/http";

@Component({
    selector: "pl-display-error",
    templateUrl: "./display-error.component.html",
    styleUrls: ["./display-error.component.scss"],
    standalone: false
})
export class DisplayErrorComponent {
  @Input() error?: HttpErrorResponse;
}
